import { render, staticRenderFns } from "./StaticFooter.vue?vue&type=template&id=78325af4&"
import script from "./StaticFooter.vue?vue&type=script&lang=js&"
export * from "./StaticFooter.vue?vue&type=script&lang=js&"
import style0 from "./StaticFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StaticFooter.vue"
export default component.exports